<template>
  <div class="order">
    <div class="flex gap-5 justify-between items-center mb-6 mdmax:flex-col">
      <div class="w-2/5 flex gap-5 justify-between mdmax:w-full mdmax:flex-col">
        <div class="flex-1">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" placeholder="Cari no order, nama pembeli" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white">
      <div class="flex items-center tab shadow-border-b mdmax:overflow-x-auto">
        <div
          class="relative px-6 py-3 cursor-pointer text-center font-medium whitespace-nowrap"
          v-for="(tab, index) in tabList"
          :key="'tab-' + index"
          :class="[tab.active ? 'active text-neutral-700' : 'text-neutral-500']"
          @click="selectTab(tab)"
        >
          {{ tab.title }}
        </div>
      </div>
      <div class="">
        <div v-for="pickup in filteredData" :key="pickup.id">
          <PickupCard :data="pickup" />
        </div>
      </div>
    </div>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
const NOW = new Date()
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Search: () => import(/* webpackChunkName: "Forms" */ '@/components/Icons/Search'),
    PickupCard: () => import(/* webpackChunkName: "card" */ '@/components/PickupCard/PickupCard'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data: () => ({
    typeList: ['Semua', 'Pickup', 'Pengiriman'],
    statusList: ['Semua', 'Pickup', 'Diproses', 'Selesai', 'Komplain'],
    selectedType: '',
    dateRange: {
      startDate: new Date(NOW.getFullYear(), NOW.getMonth(), NOW.getDate() - 7),
      endDate: NOW
    },
    tabList: [
      {
        title: 'Semua',
        active: true
      },
      {
        title: 'Internal Kurir',
        active: false
      },
      {
        title: 'External Kurir',
        active: false
      }
    ],
    selectedTab: '',
    searchTerm: '',
    totalRecords: 0,
    currentPage: 1,
    pageSize: 10
  }),
  computed: {
    ...mapGetters('assignment', ['pickupAssignment']),
    ...mapGetters('common', ['isMobile']),
    filteredData() {
      let temp = this.pickupAssignment
      if (this.searchTerm !== '' && this.searchTerm) {
        temp = temp.filter(item => {
          return item.id
            .toString()
            .toUpperCase()
            .includes(this.searchTerm.toUpperCase())
        })
      }
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  created() {
    this.selectTab(this.tabList[0])
    if (!this.$route.query.page) {
      this.$router.push({ path: '/order/pickup', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getPickupAssignmentList()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getPickupAssignmentList()
      } else {
        this.$router.push({ path: '/order/pickup', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  },
  methods: {
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('assignment', ['getPickupAssignment', 'getDriverAssignment']),
    selectTab(tab) {
      this.tabList.forEach(item => (item.active = false))
      const tabIndex = this.tabList.findIndex(item => item.title === tab.title)
      this.tabList[tabIndex].active = true
      this.selectedTab = tab
    },
    goToDetail(target) {
      this.$router.push(`/order/pickup/${target}`)
    },
    doSearch() {
      this.searchTerm = this.keyword
    },
    showMore(page) {
      this.page = page
      this.currentPage = page
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/order/pickup', query: { page: page } })
    },
    getPickupAssignmentList() {
      this.showLoading()
      this.getPickupAssignment({
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: '',
          sort: 'DESC'
        }
      })
        .then(res => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(error => {
          this.hideLoading()
          console.log('error', error.response)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.order {
  &::v-deep .vs__search {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
  }
  &::v-deep .vdpComponent {
    font-size: 16px;
    display: block;
  }
  &::v-deep .vdpComponent input {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
}
.date-range {
  &::v-deep .reportrange-text {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 2.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
  &::v-deep .vue-daterange-picker {
    display: block;
  }
}
.tab {
  .active {
    &::after {
      content: '';
      display: block;
      height: 4px;
      width: 100%;
      background-color: #61d7cf;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
}
</style>
